import React from "react";
import T from "prop-types";
import { shortDateAndTimestamp } from "LIB/formatters/date";
import { NoteTooltip } from "MODULES/shared/components";

export default function PurchasedPartWarning({
  purchase_created_at: purchaseCreatedAt,
  purchaser_contact: purchaserContact,
  purchaser_company: purchaserCompany,
  purchaser
}) {
  return (
    <div className="center-block alert alert-danger">
      <div className="media">
        <div className="media-left">
          <i className="fa fa-lg fa-warning text-danger" />
        </div>
        <div className="media-body">
          Unit was purchased from {purchaserCompany} recently! Please be careful
          quoting.
          <span style={{ marginLeft: 8 }}>
            <NoteTooltip
              placement="right"
              icon="fa-info-circle"
              color="rgba(255, 255, 255, 0.25)"
              note={`This part number was purchased/received in the last 60 days by
                      ${purchaser} from ${purchaserCompany} / ${purchaserContact} on
                      ${shortDateAndTimestamp(purchaseCreatedAt)}.
                      Please consider contacting Buyer.
                      Please be careful quoting as they might be pricing us.`}
            />
          </span>
        </div>
      </div>
    </div>
  );
}

PurchasedPartWarning.propTypes = {
  purchaser: T.string.required,
  purchaser_company: T.string.required,
  purchase_created_at: T.string.required,
  purchaser_contact: T.string.required
};



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/shared/PurchasedPartWarning.jsx